import { localize } from "utils/localizer";

const i18n = {
    filter: {
        en: "Filter",
        de: "Filtern",
    },
    query: {
        en: "Query",
        de: "Anfrage",
    },
    apply: {
        en: "Apply",
        de: "Anwenden",
    },
    isVirtualEvent: {
        en: "Virtual Event",
        de: "Virtual Event",
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    reset: {
        en: "Reset",
        de: "Zurücksetzen",
    },
    save: {
        en: "Save",
        de: "Speichern",
    },
    isBlueprint: {
        en: "Blueprint",
        de: "Vorlage",
    },
    isActive: {
        en: "Status",
        de: "Status",
    },
    title: {
        en: "Title",
        de: "Titel",
    },
    active: {
        en: "Active",
        de: "Aktiv",
    },
    inActive: {
        en: "Inactive",
        de: "Inaktiv",
    },
    startDate: {
        en: "Starts",
        de: "Startet",
    },
    endDate: {
        en: "Ends",
        de: "Endet",
    },
    description: {
        en: "Description",
        de: "Beschreibung",
    },
    numParticipants: {
        en: "Participants",
        de: "Teilnehmer",
    },
    participants: {
        en: "Participants",
        de: "Teilnehmer",
    },
    minutesPlayed: {
        en: "Minutes played",
        de: "Gespielte Minuten",
    },
    tags: {
        en: "Tags",
        de: "Tags",
    },
    sportForm: {
        en: "Sport form",
        de: "Sportart",
    },
    hasRewards: {
        en: "Reward",
        de: "Belohnung",
    },
    details: {
        en: "Details",
        de: "Details",
    },
    challengeDetails: {
        en: "Challenge Details",
        de: "Herausforderungsdetails",
    },
    actions: {
        en: "Actions",
        de: "Aktionen",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    numBookings: {
        en: "Number bookings",
        de: "Anzahl Buchungen",
    },
    createChallenge: {
        en: "Create Challenge",
        de: "Challenge erstellen",
    },
    yes: {
        en: "Yes",
        de: "Ja",
    },
    no: {
        en: "No",
        de: "Nein",
    },
    open: {
        en: "Open",
        de: "Offen",
    },
    status: {
        en: "Status",
        de: "Status",
    },
    all: {
        en: "All",
        de: "Alle",
    },
    invalidParameter: {
        en: "You need to supply the start date",
        de: "Sie müssen das Startdatum angeben",
    },
    successMsg: {
        en: "Sucessfully saved!!",
        de: "Erfolgreich gespeichert!!",
    },
    audienceGroups: {
        en: "Audience Groups",
        de: "Zielgruppen",
    },
    club: {
        en: "Club",
        de: "Club",
    },
    clubSite: {
        en: "ClubSite",
        de: "ClubSite",
    },
};

export default localize(i18n);
